import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import type { CompanyPageRoutingParams } from "app/pages/sales-intelligence/sub-modules/account-overview/shared/types/routing";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { SignalEventType } from "../../company/services/signals/types";
import { TabName } from "../../company/types/tabs";
import accountOverviewPagesService from "../services/pages/accountOverviewPagesService";

/** @deprecated Use `siNavigator.getCompanyOverviewLink` instead. */
export const createCompanyPageLink = <P extends CompanyPageRoutingParams = CompanyPageRoutingParams>(
    pageParams: P,
): string => {
    return siNavigator.getCompanyAnalysisOverviewLink(pageParams);
};

export const createWebsitePageLink = <P extends CompanyPageRoutingParams = CompanyPageRoutingParams>(
    pageParams: P,
): string => {
    return proNavigator.href(accountOverviewPagesService.getPageStateKey("website"), pageParams);
};

export const createAccountOverviewLink = (pageKey: string) => {
    return (activePageSection?: TabName): URL["href"] => {
        const section = activePageSection ? { activePageSection } : {};

        return siNavigator.getCompanyAnalysisOverviewLink({
            key: pageKey,
            ...section,
        });
    };
};

export const createSignalTypeLink = (pageKey: string) => {
    return (eventType: SignalEventType): URL["href"] => {
        return siNavigator.getCompanyAnalysisOverviewLink({
            key: pageKey,
            activePageSection: TabName.signals,
            activeSignalFilter: eventType,
        });
    };
};
